var React = require('react');

function Spotify (props) {
    return React.createElement("svg",props,React.createElement("path",{"clipRule":"evenodd","d":"M22.576 24.79c.61.405 1.32.2 1.725-.406.3-.61.201-1.42-.509-1.724-5.272-3.245-11.965-3.956-19.67-2.23-.61.202-1.116.809-.914 1.52.203.609.813 1.117 1.52.911 7.1-1.622 13.082-1.012 17.847 1.928zm2.026-5.476c.711.507 1.624.203 2.133-.507.505-.71.202-1.722-.408-2.028-6.286-3.852-15.412-4.969-22.814-2.74-.812.203-1.217 1.118-1.014 1.929.202.811 1.117 1.217 1.926 1.014 6.388-2.028 14.703-1.014 20.177 2.332zm-21.19-8.516c6.185-1.928 17.034-1.523 23.525 2.33.911.506 2.13.205 2.635-.506.507-.913.203-2.13-.708-2.637-7.505-4.463-19.369-4.869-26.568-2.74-.913.307-1.521 1.319-1.217 2.335.304.912 1.318 1.52 2.332 1.218z","fill":"#fff","fillRule":"evenodd"}));
}

Spotify.defaultProps = {"fill":"none","viewBox":"0 0 30 30"};

module.exports = Spotify;

Spotify.default = Spotify;
